import WebflowPage from "../components/WebflowPage";
import useSeo from "../lib/useSeo";

export default function Track() {
  useSeo({
    title: "Track Your Gift Card Submission — GC Nexon",
    description: "Enter your NEXON reference number to see submission status, verification progress, and payout details in real time. No account required.",
    path: "/track",
  });
  return <WebflowPage htmlPath="/site/track.html" title="Track your submission — GC Nexon" />;
}
